// extracted by mini-css-extract-plugin
module.exports = {"root":"SquareSpeciesImage_root__23uFZ","image":"SquareSpeciesImage_image__2oKSN"};